//* Libraries imports
import { ArrowRight, ShieldCheck } from "lucide-react";

type PaymentFooterProps = {
  onStartPayment: () => void;
  isLoading?: boolean;
};

export function PaymentFooter({
  onStartPayment,
  isLoading = false,
}: PaymentFooterProps) {
  return (
    <footer className="w-full max-w-3xl bg-white rounded-xl border border-clarobordas-01 shadow-sombra-01 p-6 flex flex-col gap-4">
      <button
        onClick={onStartPayment}
        disabled={isLoading}
        className="w-full h-12 bg-claroprimaria-01 text-white rounded-lg flex items-center justify-center gap-2 font-semibold text-base hover:bg-claroprimaria-01/90 transition-all shadow-md active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isLoading ? (
          "Processando..."
        ) : (
          <>
            Iniciar Pagamento
            <ArrowRight size={20} />
          </>
        )}
      </button>

      <div className="flex items-center justify-center gap-2">
        <ShieldCheck size={16} className="text-clarotexto-202" />
        <span className="text-clarotexto-202 text-xs font-medium opacity-80">
          Ambiente 100% seguro e protegido
        </span>
      </div>
    </footer>
  );
}
